export function setCsrfToken(token: string): void {
  if (window.FinancialCents) {
    window.FinancialCents.csrfToken = token
  }
  axios.defaults.headers.common["X-CSRF-TOKEN"] = token
}

export async function refreshCsrfToken(): Promise<boolean> {
  try {
    const { data } = await axios.get<{ data: { _token: string } }>("/api/contract/renew")
    const token = data?.data?._token
    if (!token) {
      return false
    }
    setCsrfToken(token)
    return true
  } catch (e: unknown) {
    console.error(e)
    return false
  }
}
